module.exports = __webpack_public_path__ + "img/404.c1b4c8ff.png";